<div class="advanced-search-modal">
  <div class="modal-header">
    <h2>Advance Search: {{searchType === 'CPP' ? 'Crop Protection Orders' : 'Seed Orders'}}</h2>
    <div class="header-actions">
      <a href="#" class="clear-link" (click)="onClearAll($event)">Clear All</a>
      <button type="button" class="close-btn" (click)="onClose()">
        <span>×</span>
      </button>
    </div>
  </div>

  <!-- CPP FORM -->
  <div class="modal-body" *ngIf="searchType === 'CPP'">
    <form [formGroup]="searchForm" class="search-form">

      <!-- Row 1: Web Order Number & Account -->
      <div class="form-row">
        <div class="form-col-left">
          <label class="field-label">Web Order Number</label>
          <input type="text" class="form-input" formControlName="webOrderNumber" maxlength="150">
        </div>
        <div class="form-col-right">
          <label class="field-label">Account</label>
          <div class="multi-select-wrapper">
            <div class="selected-display" (click)="toggleDropdown('account')">
              <span>{{getSelectedText('account')}}</span>
              <i class="dropdown-arrow" [class.open]="dropdownStates.account">▼</i>
            </div>
            <div class="dropdown-list" *ngIf="dropdownStates.account">
              <div class="dropdown-option">
                <input type="checkbox" id="account-all" [checked]="isAllSelected('account')" (change)="toggleSelectAll('account', $event)">
                <label for="account-all"><strong>Select ALL</strong></label>
              </div>
              <div class="dropdown-option" *ngFor="let option of accountOptions; let i = index">
                <input type="checkbox" [id]="'account-' + i" [checked]="selectedAccounts.includes(option.value)" (change)="toggleOption('account', option.value, $event)">
                <label [for]="'account-' + i">{{option.value}} - {{option.label}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 2: Order Number & Shipment Number -->
      <div class="form-row">
        <div class="form-col-left">
          <label class="field-label">Order Number</label>
          <input type="text" class="form-input" formControlName="orderNumber" maxlength="150">
        </div>
        <div class="form-col-right">
          <label class="field-label">Shipment Number</label>
          <input type="text" class="form-input" formControlName="shipmentNumber" maxlength="150">
        </div>
      </div>

      <!-- Row 3: Customer PO & Order Type -->
      <div class="form-row">
        <div class="form-col-left">
          <label class="field-label">Customer PO</label>
          <input type="text" class="form-input" formControlName="customerPO" maxlength="150">
        </div>
        <div class="form-col-right">
          <label class="field-label">Order Type</label>
          <div class="multi-select-wrapper">
            <div class="selected-display" (click)="toggleDropdown('orderType')">
              <span>{{getSelectedText('orderType')}}</span>
              <i class="dropdown-arrow" [class.open]="dropdownStates.orderType">▼</i>
            </div>
            <div class="dropdown-list" *ngIf="dropdownStates.orderType">
              <div class="dropdown-option">
                <input type="checkbox" id="orderType-all" [checked]="isAllSelected('orderType')" (change)="toggleSelectAll('orderType', $event)">
                <label for="orderType-all"><strong>Select ALL</strong></label>
              </div>
              <div class="dropdown-option" *ngFor="let option of orderTypeOptions; let i = index">
                <input type="checkbox" [id]="'orderType-' + i" [checked]="selectedOrderTypes.includes(option.value)" (change)="toggleOption('orderType', option.value, $event)">
                <label [for]="'orderType-' + i">{{option.label}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 4: Order Date From & Order Date To -->
      <div class="form-row">
        <div class="form-col-left">
          <div class="row">
            <div class="col-6">
              <label class="field-label">Order Date (from)</label>
              <div class="date-input-wrapper">
                <mat-form-field appearance="outline" class="w-100">
                  <input readonly matInput [matDatepicker]="orderDateFrom" formControlName="orderDateFrom" (focus)="orderDateFrom.open();" [max]="maxOrderDate">
                  <mat-datepicker-toggle matIconSuffix [for]="orderDateFrom"></mat-datepicker-toggle>
                  <mat-datepicker #orderDateFrom></mat-datepicker>
                </mat-form-field>
                <!--<mat-form-field [class.invalid-field]="element.deliveryDate?false:true">
                  <input readonly matInput [matDatepicker]="picker" (focus)="picker.open();" [matDatepickerFilter]="dateFilter"
                         [(ngModel)]="element.deliveryDate" (dateChange)="validateDate(element, $event)">
                  <mat-datepicker-toggle [disabled]="readOnlyAccess" matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker [disabled]="readOnlyAccess" #picker></mat-datepicker>
                </mat-form-field>-->

              </div>
            </div>
            <div class="col-6">
              <label class="field-label">Order Date (to)</label>
              <div class="date-input-wrapper">
                <mat-form-field appearance="outline" class="w-100">
                  <input readonly matInput [matDatepicker]="orderDateTo" formControlName="orderDateTo" (focus)="orderDateTo.open();" [min]="searchForm.get('orderDateFrom')?.value" (dateChange)="onOrderDateToChange()" [max]="maxOrderDate">
                  <mat-datepicker-toggle matIconSuffix [for]="orderDateTo"></mat-datepicker-toggle>
                  <mat-datepicker #orderDateTo></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="form-col-right">
          <label class="field-label">Vendor</label>
          <div class="multi-select-wrapper">
            <div class="selected-display" (click)="toggleDropdown('vendor')">
              <span>{{getSelectedText('vendor')}}</span>
              <i class="dropdown-arrow" [class.open]="dropdownStates.vendor">▼</i>
            </div>
            <div class="dropdown-list" *ngIf="dropdownStates.vendor">
              <div class="dropdown-option">
                <input type="checkbox" id="vendor-all" [checked]="isAllSelected('vendor')" (change)="toggleSelectAll('vendor', $event)">
                <label for="vendor-all"><strong>Select ALL</strong></label>
              </div>
              <div class="dropdown-option" *ngFor="let option of vendorOptions; let i = index">
                <input type="checkbox" [id]="'vendor-' + i" [checked]="selectedVendors.includes(option.value)" (change)="toggleOption('vendor', option.value, $event)">
                <label [for]="'vendor-' + i">{{option.label}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 5: Requested Delivery Date From & To -->
      <div class="form-row">
        <div class="form-col-left">
          <div class="row">
            <div class="col-6">
              <label class="field-label">Requested Delivery Date (from)</label>
              <div class="date-input-wrapper">
                <mat-form-field appearance="outline" class="w-100">
                  <input readonly matInput [matDatepicker]="deliveryDateFrom" formControlName="deliveryDateFrom" (focus)="deliveryDateFrom.open();" (dateChange)="onDeliveryDateFromChange()">
                  <mat-datepicker-toggle matIconSuffix [for]="deliveryDateFrom"></mat-datepicker-toggle>
                  <mat-datepicker #deliveryDateFrom></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="col-6">
              <label class="field-label">Requested Delivery Date (to)</label>
              <div class="date-input-wrapper">
                <mat-form-field appearance="outline" class="w-100">
                  <input readonly matInput [matDatepicker]="deliveryDateTo" formControlName="deliveryDateTo" (focus)="deliveryDateTo.open();" [min]="searchForm.get('deliveryDateFrom')?.value" (dateChange)="onDeliveryDateToChange()">
                  <mat-datepicker-toggle matIconSuffix [for]="deliveryDateTo"></mat-datepicker-toggle>
                  <mat-datepicker #deliveryDateTo></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="form-col-right">
          <label class="field-label">Product Name</label>
          <div class="multi-select-wrapper">
            <div class="selected-display" (click)="toggleDropdown('productName')">
              <span>{{getSelectedText('productName')}}</span>
              <i class="dropdown-arrow" [class.open]="dropdownStates.productName">▼</i>
            </div>
            <div class="dropdown-list" *ngIf="dropdownStates.productName">
              <div class="dropdown-option">
                <input type="checkbox" id="productName-all" [checked]="isAllSelected('productName')" (change)="toggleSelectAll('productName', $event)">
                <label for="productName-all"><strong>Select ALL</strong></label>
              </div>
              <div class="dropdown-option" *ngFor="let option of productNameOptions; let i = index">
                <input type="checkbox" [id]="'productName-' + i" [checked]="selectedProductNames.includes(option.value)" (change)="toggleOption('productName', option.value, $event)">
                <label [for]="'productName-' + i">{{option.value}} - {{option.label}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- SEED FORM -->
  <div class="modal-body" *ngIf="searchType === 'SEED'">
    <form [formGroup]="searchForm" class="search-form">

      <!-- Row 1: Order Number & Account -->
      <div class="form-row">
        <div class="form-col-left">
          <label class="field-label">Order Number</label>
          <input type="text" class="form-input" formControlName="orderNumber" maxlength="150">
        </div>
        <div class="form-col-right">
          <label class="field-label">Account</label>
          <div class="multi-select-wrapper">
            <div class="selected-display" (click)="toggleDropdown('account')">
              <span>{{getSelectedText('account')}}</span>
              <i class="dropdown-arrow" [class.open]="dropdownStates.account">▼</i>
            </div>
            <div class="dropdown-list" *ngIf="dropdownStates.account">
              <div class="dropdown-option">
                <input type="checkbox" id="account-all" [checked]="isAllSelected('account')" (change)="toggleSelectAll('account', $event)">
                <label for="account-all"><strong>Select ALL</strong></label>
              </div>
              <div class="dropdown-option" *ngFor="let option of accountOptions; let i = index">
                <input type="checkbox" [id]="'account-' + i" [checked]="selectedAccounts.includes(option.value)" (change)="toggleOption('account', option.value, $event)">
                <label [for]="'account-' + i">{{option.value}} - {{option.label}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 2: Customer PO & Shipment Number -->
      <div class="form-row">
        <div class="form-col-left">
          <label class="field-label">Customer PO</label>
          <input type="text" class="form-input" formControlName="customerPO" maxlength="150">
        </div>
        <div class="form-col-right">
          <label class="field-label">Shipment Number</label>
          <input type="text" class="form-input" formControlName="shipmentNumber" maxlength="150">
        </div>
      </div>

      <!-- Row 4: Order Date From & Order Date To -->
      <div class="form-row">
        <div class="form-col-left">
          <div class="row">
            <div class="col-6">
              <label class="field-label">Order Date (from)</label>
              <div class="date-input-wrapper">
                <mat-form-field appearance="outline" class="w-100">
                  <input readonly matInput [matDatepicker]="orderDateFrom" formControlName="orderDateFrom" (focus)="orderDateFrom.open();" [max]="maxOrderDate">
                  <mat-datepicker-toggle matIconSuffix [for]="orderDateFrom"></mat-datepicker-toggle>
                  <mat-datepicker #orderDateFrom></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="col-6">
              <label class="field-label">Order Date (to)</label>
              <div class="date-input-wrapper">
                <mat-form-field appearance="outline" class="w-100">
                  <input readonly matInput [matDatepicker]="orderDateTo" formControlName="orderDateTo" (focus)="orderDateTo.open();" [min]="searchForm.get('orderDateFrom')?.value" (dateChange)="onOrderDateToChange()" [max]="maxOrderDate">
                  <mat-datepicker-toggle matIconSuffix [for]="orderDateTo"></mat-datepicker-toggle>
                  <mat-datepicker #orderDateTo></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="form-col-right">
          <label class="field-label">Vendor</label>
          <div class="multi-select-wrapper">
            <div class="selected-display" (click)="toggleDropdown('vendor')">
              <span>{{getSelectedText('vendor')}}</span>
              <i class="dropdown-arrow" [class.open]="dropdownStates.vendor">▼</i>
            </div>
            <div class="dropdown-list" *ngIf="dropdownStates.vendor">
              <div class="dropdown-option">
                <input type="checkbox" id="vendor-all" [checked]="isAllSelected('vendor')" (change)="toggleSelectAll('vendor', $event)">
                <label for="vendor-all"><strong>Select ALL</strong></label>
              </div>
              <div class="dropdown-option" *ngFor="let option of vendorOptions; let i = index">
                <input type="checkbox" [id]="'vendor-' + i" [checked]="selectedVendors.includes(option.value)" (change)="toggleOption('vendor', option.value, $event)">
                <label [for]="'vendor-' + i">{{option.label}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 5: Requested Delivery Date From & To -->
      <div class="form-row">
        <div class="form-col-left">
          <div class="row">
            <div class="col-6">
              <label class="field-label">Requested Delivery Date (from)</label>
              <div class="date-input-wrapper">
                <mat-form-field appearance="outline" class="w-100">
                  <input readonly matInput [matDatepicker]="deliveryDateFrom" formControlName="deliveryDateFrom" (focus)="deliveryDateFrom.open();" (dateChange)="onDeliveryDateFromChange()">
                  <mat-datepicker-toggle matIconSuffix [for]="deliveryDateFrom"></mat-datepicker-toggle>
                  <mat-datepicker #deliveryDateFrom></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="col-6">
              <label class="field-label">Requested Delivery Date (to)</label>
              <div class="date-input-wrapper">
                <mat-form-field appearance="outline" class="w-100">
                  <input readonly matInput [matDatepicker]="deliveryDateTo" formControlName="deliveryDateTo" (focus)="deliveryDateTo.open();" [min]="searchForm.get('deliveryDateFrom')?.value" (dateChange)="onDeliveryDateToChange()">
                  <mat-datepicker-toggle matIconSuffix [for]="deliveryDateTo"></mat-datepicker-toggle>
                  <mat-datepicker #deliveryDateTo></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="form-col-right">
          <label class="field-label">Product Name</label>
          <div class="multi-select-wrapper">
            <div class="selected-display" (click)="toggleDropdown('productName')">
              <span>{{getSelectedText('productName')}}</span>
              <i class="dropdown-arrow" [class.open]="dropdownStates.productName">▼</i>
            </div>
            <div class="dropdown-list" *ngIf="dropdownStates.productName">
              <div class="dropdown-option">
                <input type="checkbox" id="productName-all" [checked]="isAllSelected('productName')" (change)="toggleSelectAll('productName', $event)">
                <label for="productName-all"><strong>Select ALL</strong></label>
              </div>
              <div class="dropdown-option" *ngFor="let option of productNameOptions; let i = index">
                <input type="checkbox" [id]="'productName-' + i" [checked]="selectedProductNames.includes(option.value)" (change)="toggleOption('productName', option.value, $event)">
                <label [for]="'productName-' + i">{{option.value}} - {{option.label}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-col-left">
          <label class="field-label">Order Type</label>
          <div class="multi-select-wrapper">
            <div class="selected-display" (click)="toggleDropdown('orderType')">
              <span>{{getSelectedText('orderType')}}</span>
              <i class="dropdown-arrow" [class.open]="dropdownStates.orderType">▼</i>
            </div>
            <div class="dropdown-list" *ngIf="dropdownStates.orderType">
              <div class="dropdown-option">
                <input type="checkbox" id="orderType-all" [checked]="isAllSelected('orderType')" (change)="toggleSelectAll('orderType', $event)">
                <label for="orderType-all"><strong>Select ALL</strong></label>
              </div>
              <div class="dropdown-option" *ngFor="let option of orderTypeOptions; let i = index">
                <input type="checkbox" [id]="'orderType-' + i" [checked]="selectedOrderTypes.includes(option.value)" (change)="toggleOption('orderType', option.value, $event)">
                <label [for]="'orderType-' + i">{{option.label}}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="form-col-right">
          <!-- Empty space -->
        </div>
      </div>

    </form>
  </div>

  <div class="modal-footer">
    <button mat-raised-button class="btns w160" color="primary" (click)="onCancel()">Cancel</button>
    <button mat-raised-button class="btns w160" color="primary" (click)="onAdvancedSearch()" [disabled]="disableAdvancedSearchButton">Advance Search</button>
  </div>
</div>
